module.exports = "/_next/static/images/53cb90fbf7b688855c87af06d90b00e1-Nubank_HickDuarte_55193_lg.jpg.webp";